
export default[
    //经销商能力胜任测评表
    {
        path: '/agent/ability',
        component: () => import( '@/views/loud/agent/ability/agentAbility.vue'),
    },
    //新增周会议
    {
        path: '/agent/addAgentAbility',
        component: () => import( '@/views/loud/agent/ability/addAgentAbility.vue'),
    },
    //审批页面
    {
        path: '/agent/shenPiAgentAbility',
        component: () => import( '@/views/loud/agent/ability/shenPiAgentAbility.vue'),
    },
    //重新提交
    {
        path: '/agent/resubmitAgentAbility',
        component: () => import( '@/views/loud/agent/ability/resubmitAgentAbility.vue'),
    },
    //查看
    {
        path: '/agent/seeAgentAbility',
        component: () => import( '@/views/loud/agent/ability/seeAgentAbility.vue'),
    },


]